import React, {useEffect, useRef} from 'react'
import {useNavigate} from 'react-router-dom'
import {useSetRecoilState} from 'recoil'
import {OrderAction} from '../../store/action'
import {alertAtom} from '../../store/recoil/alert'

const PAYVERSE_PENDING_ORDER_KEY = 'payverse.pendingOrder'
const PAYVERSE_RESULT_KEY = 'payverse.result'

const PayverseReturn = () => {
  const navigate = useNavigate()
  const setAlert = useSetRecoilState(alertAtom)
  const {order} = OrderAction()
  const started = useRef(false)

  useEffect(() => {
    if (started.current) {
      return
    }
    started.current = true

    const pendingOrder = sessionStorage.getItem(PAYVERSE_PENDING_ORDER_KEY)
    const paymentResult = sessionStorage.getItem(PAYVERSE_RESULT_KEY)

    if (!pendingOrder || !paymentResult) {
      setAlert({
        title: '결제 오류',
        type: 'alert',
        message: '결제 결과 또는 주문 정보를 찾을 수 없습니다.',
        isShow: true,
      })
      navigate('/')
      return
    }

    try {
      const orderInfo = JSON.parse(pendingOrder)
      const result = JSON.parse(paymentResult)

      if (result.resultStatus !== 'SUCCESS') {
        throw new Error(result.resultMessage || '결제가 완료되지 않았습니다.')
      }

      order({
        ...orderInfo,
        service_id: result.schemeGroup || 'PAYVERSE',
        order_id: result.orderId || '',
        track_id: result.tid || '',
        amount: String(orderInfo.total),
        trxdate: '',
        authcd: result.resultCode || '',
        response_code: result.resultCode || '',
      }).then((response) => {
        if (!response) {
          throw new Error('주문 저장에 실패했습니다.')
        }

        sessionStorage.removeItem(PAYVERSE_PENDING_ORDER_KEY)
        sessionStorage.removeItem(PAYVERSE_RESULT_KEY)
        navigate('/my/order', {replace: true})
      }).catch((error) => {
        setAlert({
          title: '주문 오류',
          type: 'alert',
          message: error?.message || '주문 처리 중 오류가 발생했습니다.',
          isShow: true,
        })
      })
    } catch (error: any) {
      sessionStorage.removeItem(PAYVERSE_RESULT_KEY)
      setAlert({
        title: '결제 오류',
        type: 'alert',
        message: error?.message || '결제 결과 처리 중 오류가 발생했습니다.',
        isShow: true,
      })
      navigate('/', {replace: true})
    }
  }, [navigate, order, setAlert])

  return <div style={{padding: '4rem', textAlign: 'center'}}>결제 결과를 처리하고 있습니다.</div>
}

export default PayverseReturn
